<template>
    <div v-if="isCycleRestarted">
        <NextStep title="Reassess Your Target Job">
            <p class="font-bold">Your interview rate is below 2%, which means we need to adjust your approach.</p>
            <br />
            <p class="font-bold">Why you're back at Stage 1:</p>
            <p>
                Recruiters hire specialists who match their exact needs. Your current target role might not be aligning
                with your experience or the way you're presenting your skills.
            </p>
            <br />
            <p class="font-bold">Your next steps:</p>
            <ol class="list-decimal ml-5">
                <li>Review your application results with JobTrackerAI</li>
                <li>Choose <span class="font-bold">ONE</span> new target role that better matches your background</li>
                <li>Realign your resume to this new focus</li>
            </ol>
            <br />
            <p>
                This adjustment is normal and data-driven. Many successful job seekers pivot based on market feedback!
            </p>
        </NextStep>
    </div>
    <div v-else-if="isStepPassed">
        <NextStep title="Review">
            <p>You've selected your target job title: a crucial foundation for your search.</p>
            <br />
            <p>
                This focused approach has aligned your job search strategy and positioned you as a specialist rather
                than a generalist.
            </p>
        </NextStep>
    </div>
    <div v-else>
        <NextStep title="Choose Your Target Job">
            <p>Recruiters hire <span class="font-bold">specialists</span>, not generalists.</p>
            <br />
            <p>
                So your goal is to identify <span class="font-bold">ONE</span> specific job title that becomes the focus
                of your entire search.
            </p>
            <br />
            <p>
                This might change in the future, but for now, focusing on a single target role allows you to create a
                perfectly aligned resume that compels recruiters.
            </p>
            <br />
            <p class="font-bold">How to complete this stage:</p>
            <ol class="list-decimal ml-5">
                <li>Choose <span class="font-bold">ONE</span> target role that matches your skills and experience</li>
                <li>Research job requirements to understand what employers want</li>
                <li>Connect JobTrackerAI to track your progress through each stage</li>
            </ol>
            <br />
            <p>
                JobTrackerAI turns your resume, application, and interview data into useful insights that improve your
                job search.
            </p>
        </NextStep>
    </div>

    <button
        class="bg-won-green w-full text-white py-1.5 px-3 rounded text-sm target-job-stage-btn"
        type="button"
        @click="() => emit('open-feature')"
    >
        {{ isCycleRestarted ? "Explore Better-Matching Roles →" : "Connect JobTrackerAI Now →" }}
    </button>
</template>

<script setup>
import NextStep from "../next-step.vue";

const emit = defineEmits(["open-feature"]);
const props = defineProps({
    isCycleRestarted: {
        type: Boolean,
        default: false,
    },
    isStepPassed: {
        type: Boolean,
        default: true,
        required: true,
    },
});
</script>
